@let showsSelected = challenge().isSelected || previewSelected();

<div class="card" [id]="challenge().offerId">
  <div
    class="un-card-header"
    [style.height]="config().header.height"
    [style.backgroundColor]="config().header.backgroundColor"
  >
    <!-- Logo -->
    @if (shouldShowLogo()) {
      <div class="logo-container">
        <div class="box">
          <img alt="" class="logo" [src]="challenge().productScope.logoPath" />
        </div>
      </div>
    }

    <div class="banner">
      @if (loadBannerInPriority()) {
        <img
          fill
          priority
          class="img responsive-width"
          [alt]="challenge().getChallengeName()"
          [ngSrc]="
            challenge().hasBanner()
              ? challenge().productScope.bannerPath!!
              : config().header.backgroundImage
          "
        />
      } @else {
        <img
          fill
          class="img responsive-width"
          [alt]="challenge().getChallengeName()"
          [ngSrc]="
            challenge().hasBanner()
              ? challenge().productScope.bannerPath!!
              : config().header.backgroundImage
          "
        />
      }
    </div>

    <!-- Selection Button -->
    @if (challenge().canBeUnselected(phase())) {
      <b2c-unselection-button
        [phase]="phase()"
        [challenge]="challenge()"
        [isBisCampaign]="isBisCampaign()"
        [isEventChallenge]="isEventChallenge()"
      />
    }
  </div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style]="{
      color: config().subHeader.color,
      fontFamily: config().subHeader.fontFamily,
      fontSize: config().subHeader.fontSize,
      backgroundColor: challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor,
    }"
  >
    @let title = challenge().productScope.label[shortLocale];
    <div
      class="label"
      b2cTooltipIfTruncated
      [b2cTooltipHideDelay]="80"
      [b2cTooltipShowDelay]="120"
      [b2cTooltipPosition]="'above'"
      [b2cTooltip]="title.toString()"
    >
      {{ title }}
    </div>

    @if (!challenge().isCompleted && phase() !== CampaignPhase.COMPLETED) {
      <b2c-icon
        b2cElement
        class="scanner-icon"
        modalType="scanner"
        data-cy="check_product_btn"
        [icon]="config().subHeader.icon.imageUrl"
        [disabled]="this.challenge().isOutOfStock()"
        [buttonTitle]="config().subHeader.icon.title!"
        (click)="displayDialog(challenge(), title.toString())"
      />
    }
  </div>

  <div class="card-bottom">
    @if (challenge().isCompleted) {
      <b2c-win-card
        class="win-container"
        [amount]="challenge().maxPotentialReward"
      />
    } @else {
      <div class="card-content">
        <b2c-progress-section [config]="config()" [challenge]="challenge()" />
      </div>

      <div class="card-footer" [style.color]="config().footer.color">
        <img alt="" class="icon" [src]="config().footer.icon" />
        <span class="label" [style.fontFamily]="config().footer.fontFamily"
          >{{ config().footer.label }}:
        </span>
        <span
          class="amount-spent"
          [style.fontFamily]="config().footer.spentAmount.fontFamily"
        >
          {{ challenge().progress | formatAmount: 'currency' }}
        </span>
      </div>
    }

    <!-- Selection Button -->
    @if (!showsSelected) {
      <div class="overlay">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          class="selection-button"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
